<mat-dialog-content>
  <h2 mat-dialog-title class="mc-vert-tb">{{ info }}</h2>
  <p class="dialog-text">{{ title }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="!hideCancelButton" mat-raised-button mat-dialog-close
    class="mr-2 w-button button-cancel">
    {{ 'dialog_confirm.buttons.cancel' | translate }}
  </button>
  <button mat-raised-button tabindex="0" color="primary"
    (click)="confirmar()"
    class="w-button mr-2 button-actions font-clear">
    {{ stringAceptar() | translate }}
  </button>
</mat-dialog-actions>